import { tradeApi } from '@lib/axios';
import { apiCall } from './api-utils';

const BASE = '/v1';

export const loginUser = (data) =>
  apiCall(
    () =>
      tradeApi.post(`${BASE}/user-login`, {
        email: data.email,
        password: data.password,
        gtoken: data.gtoken ?? '',
        path: window.location.host,
      }),
    'loginUser',
  );

export const registerUser = (data) =>
  apiCall(
    () =>
      tradeApi.post(`${BASE}/user`, {
        firstName: data.fname,
        lastName: data.lname,
        mobile: data.mobile,
        email: data.email,
        password: data.password,
        gtoken: data.gtoken ?? '',
        path: window.location.host,
        referralId: data.rc ?? '',
      }),
    'registerUser',
  );

export const verifyEmail = (token) =>
  apiCall(() => tradeApi.post(`${BASE}/verify-email`, { token }), 'verifyEmail');

export const forgotPassword = (email) =>
  apiCall(
    () => tradeApi.post(`${BASE}/password-reset-request`, { email }),
    'forgotPassword',
  );

export const resetPassword = (token, password) =>
  apiCall(
    () => tradeApi.post(`${BASE}/password-reset`, { resetToken: token, password }),
    'resetPassword',
  );

export const logoutUser = (email, loginSecret) =>
  apiCall(
    () => tradeApi.post(`${BASE}/user-logout`, { email, loginSecret }),
    'logoutUser',
  );